import React from 'react';

import { 
         Text,
         Button,
         ButtonGroup,
         DescriptionList,
         Banner,
         Box,
         InlineStack
       } from '@shopify/polaris';

import { ArrowDownIcon, ArrowUpIcon } from '@shopify/polaris-icons';

const TemplateLineOrderContainer = ({
  barcode,
  storeLogo,
  barcodeSymbol,
  sku,
  productName,
  optionOne,
  optionTwo,
  optionThree,
  price,
  brand,
  arbitraryText,
  barcodeSymbolPriority,
  skuPriority,
  productNamePriority,
  optionOnePriority,
  optionTwoPriority,
  optionThreePriority,
  pricePriority,
  brandPriority,
  arbitraryTextPriority,
  increasePriority,
  decreasePriority
}) => {

  let lineElements = [];

  if (barcodeSymbol) {
    lineElements.push({
      element: 'Barcode Symbol',
      priority: barcodeSymbolPriority
    })
  }

  if (sku) {
    lineElements.push({
      element: 'SKU',
      priority: skuPriority
    })
  }

  if (productName) {
    lineElements.push({
      element: 'Product Name',
      priority: productNamePriority
    })
  }

  if (optionOne) {
    lineElements.push({
      element: 'Variation Option 1',
      priority: optionOnePriority
    })
  }

  if (optionTwo) {
    lineElements.push({
      element: 'Variation Option 2',
      priority: optionTwoPriority
    })
  }

  if (optionThree) {
    lineElements.push({
      element: 'Variation Option 3',
      priority: optionThreePriority
    })
  }

  if (price) {
    lineElements.push({
      element: 'Price',
      priority: pricePriority
    })
  }

  // if (brand) {
  //   lineElements.push({
  //     element: 'Brand',
  //     priority: brandPriority
  //   })
  // }

  // if (arbitraryText) {
  //   lineElements.push({
  //     element: 'Branding Text',
  //     priority: arbitraryTextPriority
  //   })
  // }

  lineElements.sort((a,b) => a.priority - b.priority)

  if(barcode) {
    return(
      <Banner
        title="Barcode Line"
        tone="info"
        onDismiss={() => {}}
      >
        <Text>Only the barcode appears on barcode lines. Text elements on this line will not appear.</Text>
      </Banner>
    )
  }

  if(storeLogo) {
    return(
      <Banner
        title="Store Logo Line"
        tone="info"
        onDismiss={() => {}}
      >
        <Text>Only the logo appears on store logo lines. Text elements on this line will not appear.</Text>
      </Banner>
    )
  }

  if(lineElements.length === 0) {
    return (
      <Banner
        title="Empty Line"
        tone="warning"
        onDismiss={() => {}}
      >
        <Text>No text elements selected for this line. Enable an element and select this line number from its dropdown in the "Label Parts" section to add to this line.</Text>
      </Banner>
    )
  }

  const lineElementRowData = lineElements.map(element => (
    {
      term: 
        <Box id={`ordering-title-${element.priority}`}>
          <Text variant="headingSm" as="h6">{element.element}</Text>
        </Box>,
      description:
        <Box id={`ordering-row-${element.priority}`}>
          <InlineStack align="end">
            <ButtonGroup>
              <Button icon={ArrowUpIcon} onClick={() => increasePriority(element, lineElements)}>Increase Priority</Button>
              <Button icon={ArrowDownIcon} onClick={() => decreasePriority(element, lineElements)}>Decrease Priority</Button>
            </ButtonGroup>
          </InlineStack>
        </Box>
    }
  ))

  return (
    <Box background="bg-surface-secondary" padding="400">
      <Text variant="headingMd" as="h6">Line Parts Order</Text>
      <Box padding="400">
        <DescriptionList
          items={lineElementRowData}
        />
      </Box>
    </Box>
  )

}

export default TemplateLineOrderContainer;